import {
    IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle,
    IonContent,
    IonSpinner, useIonToast
} from "@ionic/react";
import React, {useEffect, useState} from "react";
import {errorToastOptions} from "../../components/ErrorToast";
import {getUser} from "../../repositories/adminUserRepository";
import {AdminManageUserAccess2Accesses} from "../../components/admin/AdminManageUserAccess2Accesses";

export const AdminUserManagedAccesses = ({userId}) => {
    const [user, setUser] = useState(null);
    const [presentToast] = useIonToast();

    useEffect(() => {
        let isCurrent = true;
        setUser(null);
        getUser(userId)
            .then(response => {
                if (isCurrent) setUser(response.user);
            })
            .catch(e => {
                const message = typeof e.response?.data === 'string' && e.response.data ? e.response.data : "Failed to load user";
                presentToast(errorToastOptions(message));
            });
        return () => {
            isCurrent = false;
        };
    }, [userId, presentToast]);

    if (!user) {
        return <IonContent fullscreen>
            <div className="custom-spinner">
                <IonSpinner></IonSpinner>
            </div>
        </IonContent>
    }

    return <IonContent fullscreen>
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{ user.name }</IonCardTitle>
                <IonCardSubtitle>Accesses of other users this user can see or change</IonCardSubtitle>
            </IonCardHeader>
        </IonCard>
        <AdminManageUserAccess2Accesses user={user} />
    </IonContent>
}
